<template>
  <div class="main-container">
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="reloadPage()"></vk-offcanvas-close>
        <h3>
          Maintenance Details
          <el-button size="sm" style="float:right;" type="primary" @click="showStatusModal = true">
            Change Status
            <!-- <span class="fa fa-plus"></span> -->
          </el-button>
        </h3>

        <hr />

        <el-card class="box-card">
          <div style="display: flex; justify-content: space-between;" slot="header">
            <div
              style="display: flex; flex-flow: column;"
              v-if="selectedMaintenance['installation']"
            >
              <h4 style="margin: 0px;">{{selectedMaintenance['installation']['name']}}</h4>
              <small
                class="maintenance-details"
              >{{selectedMaintenance['installation']["deviceType"]["name"]}}</small>
              <small
                class="maintenance-details"
              >{{selectedMaintenance['installation']["solarKitIds"]}}</small>
            </div>
            <div
              style="display: flex; flex-flow: column;"
              v-if="selectedMaintenance['installation']"
            >
              <h4
                style="margin: 0px;"
              >{{selectedMaintenance['operationsEngineer']['firstName']}} {{selectedMaintenance['operationsEngineer']['lastName']}}</h4>
              <small
                class="maintenance-details"
              >{{selectedMaintenance['operationsEngineer']["email"]}}</small>
              <small
                class="maintenance-details"
              >{{selectedMaintenance['operationsEngineer']["phoneNumber"]}}</small>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <b-badge
              pill
              variant="primary"
              style="font-size: 10px;"
            >{{new Date(selectedMaintenance['start']).toDateString()}}</b-badge>
            <!-- <div style="border-top: 1px solid #424242;"> -->
            <hr style="width: 100%; margin: 0px;" />
            <!-- </div> -->
            <b-badge
              pill
              variant="secondary"
              style="font-size: 10px;"
            >{{new Date(selectedMaintenance['end']).toDateString()}}</b-badge>
          </div>
          <div class="description" style="margin-top: 10px;">{{selectedMaintenance['issue']}}</div>
        </el-card>
        <hr />
        <div>
          <ckeditor :editor="editor"></ckeditor>
        </div>
        <hr />
        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
          <h2>Pictures</h2>
          <el-button>Upload Picture</el-button>
        </div>

        <el-carousel height="150px">
          <el-carousel-item v-for="item in 4" :key="item">
            <h3 class="small">{{ item }}</h3>
          </el-carousel-item>
        </el-carousel>
        <!-- <el-card
          class="box-card"
          v-for="(comment_, index_) in selectedMaintenance['comments']"
          :key="`maintenance_comment_${index_}`"
        >
          <span class="fa fa-comment" style="color: grey;"></span>
          &nbsp; {{comment_['content']}}
          <hr />
          <p>
            <span
              class="fa fa-user"
            >{{comment_['user']?`${comment_['user']['firstName']} ${comment_['user']['lastName']}`:'--'}}</span>
          </p>
        </el-card>-->
        <Center style="margin-top: 10px;">
          <!-- @click="showCommentModal = true" -->
          <el-button size="sm" type="primary" >Save</el-button>
        </Center>
      </div>
    </vk-offcanvas>
    <!-- <el-form class="form" ref="form" :model="statusForm" label-width="120px"> -->
    <vk-modal :show.sync="showStatusModal">
      <div class="d-block text-center">
        <vk-modal-close @click="showStatusModal = false"></vk-modal-close>
        <h3>Status</h3>
        <hr />
        <el-form-item label="Status">
          <el-select v-model="statusValue" placeholder="Change Status">
            <el-option
              v-for="item in statusOption"
              :key="item.value"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button
          size="sm"
          style="margin-top:10px;"
          type="primary"
          @click="submitStatus()"
        >Change Status</el-button>
      </div>
    </vk-modal>
    <!-- </el-form> -->
    <el-form class="form" ref="form" :model="commentForm" label-width="120px">
      <vk-modal :show.sync="showCommentModal">
        <!-- <div style="text-align: left !important;"> -->
        <!-- Comment -->
        <!-- <img src="/static/img/modal/8.png" alt="" class="">
        <vk-modal-title>Post Comment</vk-modal-title>-->
        <!-- </div> -->
        <div class="d-block text-center">
          <vk-modal-close @click="showCommentModal = false"></vk-modal-close>
          <h3>Comment</h3>
          <hr />
          <el-form-item label="Comment">
            <el-input placeholder="Type Comment" type="textarea" v-model="commentForm.content"></el-input>
          </el-form-item>
          <el-button size="sm" style="margin-top:10px;" type="primary" @click="submitComment()">
            Post Comment
            <!-- <span class="fa fa-plus"></span> -->
          </el-button>
        </div>
      </vk-modal>
    </el-form>
    <div style="width: 100%;">
      <el-input
        style="max-width: 200px"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :columns="fields"
        :rows="maintenanceList"
        :search-options="{enabled: true,
        searchFn: searchTable,
                externalQuery: searchTerm}"
        :pagination-options="{enabled: true}"
      >
        <template slot="table-row" slot-scope="props" style="background: red;">
          <span
            v-if="props.column.field == 'installation.name'"
          >{{ props.row['installation']['name']+ " ("+ props.row['installation']['deviceType']['name']+")" }}</span>
          <span
            v-else-if="props.column.field == 'operationsEngineer.name'"
          >{{ props.row['operationsEngineer']['firstName']+ " "+ props.row['operationsEngineer']['lastName'] }}</span>
          <span
            v-else-if="props.column.field == 'start'"
          >{{ new Date(props.row['start']).toDateString() }}</span>
          <span
            v-else-if="props.column.field == 'end'"
          >{{ new Date(props.row['end']).toDateString() }}</span>
          <span v-else-if="props.column.field == 'status'">
            <b-badge
              :variant="props.row['status'] == 'close'?`danger`: `info`"
            >{{ props.row['status'] ?props.row['status']: 'open' }}</b-badge>
          </span>
          <span v-else>{{props.row[props.column.field]}}</span>
          <span v-if="props.column.field == 'actions'">
            <!-- <b-button-group> -->
            <el-button type="primary" @click.stop="viewMaintenance(props.row)">View</el-button>
            <!-- <el-select v-model="statusValue" placeholder="Change Status">
                <el-option
                  v-for="item in statusOption"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
            </el-select>-->
            <!-- </b-button-group> -->
          </span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
import { mapGetters } from "vuex";
import moment from "moment";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Carousel,
  CarouselItem
  // ...
} from "element-ui";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  // components: {
  //   Inventory
  // },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      editor: ClassicEditor,
      showOffCanvas: false,
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      items: items,
      statusValue: null,
      statusOption: [
        {
          value: 1,
          name: "open"
        },
        {
          value: 2,
          name: "close"
        },
        {
          value: 3,
          name: "completed"
        }
      ],
      fields: [
        {
          field: "installation.name",
          label: "installation",
          sortable: "true"
        },
        {
          field: "customerId",
          label: "CID",
          sortable: "true"
        },
        {
          field: "issue",
          label: "Issue/Enquiry",
          sortable: "true"
        },
        {
          field: "operationsEngineer.name",
          label: "Engineer",
          sortable: "true"
        },
        {
          field: "start",
          label: "Timeline Begins",
          sortable: "true"
        },
        {
          field: "end",
          label: "Timeline End",
          sortable: "true"
        },
        {
          field: "status",
          label: "Status",
          sortable: "true"
        },
        {
          field: "actions",
          label: "Actions"
        }
      ],

      commentForm: {
        content: null,
        maintenanceId: null,
        userId: null
      },
      showStatusModal: false,
      showCommentModal: false,
      maintenanceList: "",
      selectedMaintenance: {},
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },
  components: {
    "el-carousel": Carousel,
    "el-carousel-item": CarouselItem,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose
  },
  computed: {
    ...mapGetters(["getUserById", "getDummy", "getUserSession"]),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  methods: {
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    reloadPage() {
      this.showOffCanvas = false;
      window.location.reload();
    },
    submitStatus() {
      const maintenance = this.selectedMaintenance;
      const httpUtils = this.$httpUtils;
      //console.log(maintenance);
      let data = {
        status: this.statusValue
      };
      //console.log(data);
      const url = `/maintenance/${maintenance.id}`;
      const container = this;
      httpUtils.instance
        .patch(url, data)
        .then(response => {
          //console.log(response.data);
          container.showInfoMsg({
            message: "Status updated"
          });
          container.showStatusModal = false;
        })
        .catch(error => {
          console.log(error);
          container.showErrorMsg({
            message: error
          });
        });
    },
    submitComment() {
      const maintenance = this.selectedMaintenance;
      const httpUtils = this.$httpUtils;
      //console.log(maintenance);
      this.commentForm = {
        ...this.commentForm,
        userId: this.getUserSession.id,
        maintenanceId: maintenance["id"]
      };
      //console.log(this.commentForm);
      const url = `/maintenance_comments`;
      const container = this;
      httpUtils.instance
        .post(url, this.commentForm)
        .then(response => {
          //console.log(response.data);
          container.showInfoMsg({
            message: "Comment Added"
          });
          container.showCommentModal = false;
          let _tmpData = {
            ...response.data,
            user: container.getUserSession
          };
          //maintenance = maintenance.push(response.data);
          //container.selectedMaintenance = container.selectedMaintenance['comments'].push(response.data);
          //console.log(container.selectedMaintenance["comments"]);
          container.selectedMaintenance = {
            ...container.selectedMaintenance,
            comments: [...container.selectedMaintenance.comments, _tmpData]
          };
          //console.log(this.selectedMaintenance);
          // console.log(updated);
          // container.viewMaintenance(updated);
        })
        .catch(error => {
          console.log(error);
          container.showErrorMsg({
            message: error
          });
        });
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    viewMaintenance(maintenance) {
      this.selectedMaintenance = maintenance;
      console.log(this.selectedMaintenance);
      this.showOffCanvas = true;
      // this.$router.push({
      //   path: `/device/${deviceId}`
      // });
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    init() {
      const httpUtils = this.$httpUtils;
      let userId = this.getUserSession.id;
      let realm = this.getUserSession.realm;
      // {"include": ["installation","operationsEngineer"]}
      let url = `/maintenance?filter={"where":{"assignedTo":${userId}},"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      if (this.$can("am", "engineer")) {
        url = `/maintenance?filter={"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      } else if (this.$can("manage", "customer")) {
        url = `/maintenance?filter={"where":{"realm":{"$regex" :"^${realm}"}},"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      } else if (this.$can("read", "all")) {
        url = `/maintenance?filter={"where":{"status":"open"},"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      }
      httpUtils.instance
        .get(url)
        .then(response => {
          this.maintenanceList = response.data;
        })
        .catch(error => {
          this.errors = "Error occured at our end!";
          this.maintenanceList = "";
        });
    }
  },
  async mounted() {
    this.init();

    // console.log(this.getDummy)
  }
};
</script>

<style lang="scss" scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}
.p__component_list {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  cursor: pointer;
  .component_list_left {
    display: flex;
    flex-flow: row;
    justify-content: space-evenly;
    align-items: center;
    flex: 1;
    h2 {
      font-size: 17px;
      text-transform: capitalize;
      flex: 1;
    }
    h4 {
      margin-left: 100px;
      flex: 1;
    }
  }
}
.box-card {
  margin-top: 20px;
}
.maintenance-details {
  font-size: 10px;
}
</style>
<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/enquiries/index.vue